import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function EditPackPrice(){

    const {id}=useParams();
    const [packcats,setpackcats] = useState([]);
    const [insur,setInsur] = useState([]);
    const [priceData,setpriceData]=useState({
        "pack":'',
        "insur":'',
        "amount":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'create-pack/')
            .then(function (response) {
                setpackcats(response.data);
            });
        }catch(error){
            console.log(error);
        }
        try{
            axios.get(`${baseUrl}insur-cmpy/`)
      .then(response => {
        setInsur(response.data);
      })
        }catch(error){
            console.log(error);
        }
        },[]);

     useEffect(() => {
        try{
            axios.get(baseUrl+'edit-pack-price/'+id)
            .then(function (response) {
                setpriceData({
                    insur:response.data.insur.id,
                    pack:response.data.pack.id,
                    amount:response.data.amount,
                });
            });
        }catch(error){
            console.log(error);
        }
    },[]);

    const handleChange = (event) => {
        setpriceData({
            ...priceData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('pack',priceData.pack);
        _formData.append('insur',priceData.insur);
        _formData.append('amount',priceData.amount);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

        try{
            axios.put(baseUrl+'edit-pack-price/'+id, _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:3000,
                        showConfirmButton: false
                    });
               }
               setTimeout(() => {
                  window.location.href = ('/pack-price');
                }, 3000);
            });
            }catch(error){
                console.log(error);
            }
        };

    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Edit Package Price</h4>
                    <div className='card-body'>
                        <form>
                        <div className="mb-3">
                           <label htmlFor="pack" className="form-label">Package SubCategory</label>
                            <select name="pack" value={priceData.pack} onChange={handleChange} className="form-control">
                            <option>Choose Package SubCategory </option>
                                {packcats.map((category,index) => {return <option key={index} value={category.id}>{category.packsubcat}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="insur" className="form-label">Insurance</label>
                            <select name="insur" value={priceData.insur} onChange={handleChange} className="form-control">
                            <option>Choose Insurance</option>
                                {insur.map((insurer,index) => {return <option key={index} value={insurer.id}>
                                {insurer.company}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="amount" className="form-label">Amount</label>
                            <input type="number" className="form-control" name="amount" value={priceData.amount}
                            onChange={handleChange} id="amount" required/>
                          </div>

                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
)
}
export default EditPackPrice;